import NumberFormatInput from "react-number-format";
import { TextField } from "@material-ui/core";

const NumberInput = (props) => {
  return (
    <NumberFormatInput
      {...props}
      variant="outlined"
      customInput={TextField}
    ></NumberFormatInput>
  );
};

export default NumberInput;
